module.exports = __webpack_public_path__ + "img/orange-header-ar.29839afd.png";